import { IconDeviceFloppy } from "@tabler/icons-react";
import { Button } from "src/components/shared/Button/Button";
import { crumb } from "src/utils";

interface Props {
  handleSave: () => void;
  isLoading: boolean;
}

const SaveButton = ({ handleSave, isLoading }: Props) => {
  const handleClick = () => {
    // Log save button click
    crumb("Save Button: Clicked", {
      component: "Organize/SaveButton",
      isLoading,
    });
    
    handleSave();
  };

  return (
    <Button
      onClick={handleClick}
      loading={isLoading}
      leftIcon={<IconDeviceFloppy size={"1.4rem"} />}>
      Save
    </Button>
  );
};

export default SaveButton;
